import { css } from '@inter-ikea-kompis/web-component';

import { Table, Text } from '@ingka/common-styles-webc';

export default class EnergyFicheCardStyle {
	public static getStyle(): string {
		return css`
			${Table.CSS}
			${Text.CSS}

			/* TODO vertical-align is overriding user agent stylesheet, Skapa doesn't expose this yet. */
			td {
				vertical-align: top;
			}
		`;
	}
}
